<template>
  <div class="kpt-configurator-contactus m-4 p-4">
    <h2 class="has-text-centered title"><strong>Contact Us</strong></h2>
    <p>We are here to help and answer any questions you might have. If you have a unique quote request that cannot be configured with this tool, outline your request below.</p><br>
    <p>Please complete the form below to reach a Kymeta sales representative.  An asterisk (<span class="has-text-danger has-text-weight-bold">*</span>) indicates required information.</p>
    <hr>
    <div class="configurator-contact">
      <div class="configurator-contact-information">
        <b-field label="Contact Name" required>
          <b-input expanded type="text" v-model="contactName"></b-input>
        </b-field>
        <b-field label="Contact Email" required>
          <b-input type="email" v-model="contactEmail"></b-input>
        </b-field>
        <b-field label="Company Name" required>
          <b-input type="text" v-model="contactCompany"></b-input>
        </b-field>
      </div>
      <b-field label="Message" required>
        <b-input type="textarea" v-model="message"></b-input>
      </b-field>
      <div class="has-text-centered">
        <b-button rounded size="is-small" class="is-uppercase" type="is-dark" @click="postMessage">Submit</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed, getCurrentInstance } from 'vue';

export default {
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const am = computed(() => root.$store.getters['configurator/analyticsMetadata']);
    const message = ref(null);
    const contactName = ref(null);
    const contactEmail = ref(null);
    const contactCompany = ref(null);

    const postMessage = async () => {
      if (!contactName.value || !contactEmail.value || !contactCompany.value || !message.value) {
        root.$buefy.dialog.alert({
          title: 'Incomplete Form',
          message: 'Please fill out the required fields prior to submitting your message.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'exclamation-circle',
          ariaRole: 'alertdialog',
          ariaModal: true
        });
        return;
      }

      const result = await root.$store.dispatch('configurator/submitContactForm', {
        name: contactName.value,
        company: contactCompany.value,
        email: contactEmail.value,
        message: message.value
      });
      if (result) {
        root.$buefy.snackbar.open({
          message: 'Your message was sent successfully.',
          type: 'is-success',
          position: 'is-bottom',
          actionText: 'OK',
          indefinite: false,
          duration: 5000,
          onAction: () => {
            message.value = null;
            contactName.value = null;
            contactEmail.value = null;
            contactCompany.value = null;
            root.$store.commit('configurator/setActivePage', 0);
          }
        });

        root.$kya.event('configurator', 'sendContactUsMessage', 'Sent a Contact Us message.', { 
          ...am.value, name: contactName.value, email: contactEmail.value, company: contactCompany.value
        });
      }
    }

    return {
      message,
      contactName,
      contactEmail,
      contactCompany,
      postMessage
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-configurator-contactus {
  background: white;
  .configurator-contact-information {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;
  }
}
</style>
